// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3Effe","dragIcon":"Choice_dragIcon__8M0FP","left":"Choice_left__3_s87","input":"Choice_input__37z24"};